module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/redux-first-router/~/isarray/index.js
// module id = 1341
// module chunks = 0